import { render, staticRenderFns } from "./mallReport.vue?vue&type=template&id=03fe7c44&scoped=true&"
import script from "./mallReport.vue?vue&type=script&lang=js&"
export * from "./mallReport.vue?vue&type=script&lang=js&"
import style0 from "./mallReport.vue?vue&type=style&index=0&id=03fe7c44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fe7c44",
  null
  
)

export default component.exports